import React from 'react';
import { TopBar } from '../components/TopBar';
import { Navbar } from '../components/Navbar';
import { Hero } from '../components/Hero';
import { About } from '../components/About';
import { Experiences } from '../components/Experiences';
import { Gallery } from '../components/Gallery';
import { HowWeWork } from '../components/HowWeWork';
import { MiddleText } from '../components/MiddleText';
import { Testimonials } from '../components/Testimonials';
import { FAQ } from '../components/FAQ';
import { FinalCTA } from '../components/FinalCTA';
import { Contact } from '../components/Contact';
import { Footer } from '../components/Footer';
import { FloatingWhatsApp } from '../components/FloatingWhatsApp';
import { LanguageProvider } from '../lib/i18n';
export function PicnicTenerifePage() {
  return <LanguageProvider data-id="element-301">
      <div className="bg-sand text-volcanic min-h-screen overflow-x-hidden font-sans selection:bg-terracotta selection:text-ivory" data-id="element-302">
        <TopBar data-id="element-303" />
        <Navbar data-id="element-304" />
        <Hero data-id="element-305" />
        <About data-id="element-306" />
        <Experiences data-id="element-307" />
        <Gallery data-id="element-308" />
        <HowWeWork data-id="element-309" />
        <Testimonials data-id="element-310" />
        <MiddleText data-id="element-311" />
        <FAQ data-id="element-312" />
        <FinalCTA data-id="element-313" />
        <Contact data-id="element-314" />
        <Footer data-id="element-315" />
        <FloatingWhatsApp data-id="element-316" />
      </div>
    </LanguageProvider>;
}